// src/lib/contentful/client.ts
import { GraphQLClient } from "graphql-request";
import { getSdk } from "../../generated/contentful-sdk.mjs";
var getContentfulClient = ({
  token,
  spaceId,
  environment,
  endpoint = "https://graphql.contentful.com/content/v1/spaces"
}) => {
  const target = [endpoint, spaceId];
  if (environment && environment !== "master") {
    target.push(`environments/${environment}`);
  }
  const client = new GraphQLClient(target.join("/"), {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return getSdk(client);
};
export {
  getContentfulClient
};
